module.exports = __webpack_public_path__ + "media/src/assets/images/about_company-bg-8e57148408dd818a6e76b1408b86af18.jpg";